import {
  TIM,
  TIMUploadPlugin,
  getMessageListRecord,
  getImUserSig
} from '@/timpackage/config/config.js'
import { formatImMessage } from './formatImMessage.js'
import store from '@/store/index.js'
import { NativeMessageNotice } from '@/utils/nativeBridge/nativeMessage/index.js'
import { Dialog } from 'vant'

let imInstance = null // im 实例
let isRelogin = false // 自动登录锁
let taskQueue = new Set() // im未准备好收集任务，准备好后按顺序执行
let backgroundAudio = null // 视频通话背景音乐
const liveUrl = 'subpackage/timpackage/pages/live/live' // 视频通话路由
let isOpenVideoModel = false // 是否已经打开视频邀请model
let lastMessageTime = 0 // 发送、接收最新消息展示的时间

export const getElementBoundingClientReact = (id, _this) => {
  // 获取当前元素信息（大小，位置）
  return new Promise((resolve, reject) => {
    const dom = document.querySelector(id)
    const rect = dom.getBoundingClientRect()
    resolve(rect)
  })
}

const reLogin = async () => {
  // 被踢或者掉线重新登录
  const imId = store.state.imId
  if (isRelogin || !imId) {
    return
  }
  // isRelogin = true
  try {
    // await imLogin(store.state.IM.imSign)
    await initIm(imId)
  } catch (e) {
    console.log(e.code, e.message, isRelogin, 'relogin---------------')
  }
  isRelogin = false // 报错后可以再次尝试重新登录
}

// const initBackgroundAudio = () => {
//   // 添加视频声音提醒
// backgroundAudio = uni.createInnerAudioContext()
//   backgroundAudio.src = 'static/video_call.wav'
//   console.log(backgroundAudio)
//   backgroundAudio.play()
//   backgroundAudio.onEnded(() => {
//     backgroundAudio && backgroundAudio.play()
//   })
//   return backgroundAudio
// }

const canEnterRoom = () => {
  // eslint-disable-next-line
  const pages = getCurrentPages()
  console.log(pages, pages[pages.length - 1].route, '当前页面')
  if (pages[pages.length - 1] && pages[pages.length - 1].route === liveUrl) {
    // 当前视频通话中不可再接通视频
    return false
  }
  return true
}

// invited： true 别人要求我视频, '' 我发起视频
export const toVideoCall = (data, cb, invited = false) => {
  const nativeBridge = Vue.prototype.$nativeBridge
  // uni.navigateTo({
  //   url: '/timpackage/pages/videoCall/videoCall'
  // })
  if (isOpenVideoModel) {
    // 解决出现多次提示，不能手动关闭model
    return
  }
  isOpenVideoModel = true
  const {
    isMe, // 自己发起视频：true; 被邀请：undefined
    content: {
      id,
      visitType,
      userIDList,
      roomID,
      fromName,
      visitID,
      lowerDoctorIDFromIM,
      lowerDoctorName,
      doctorIDFromIM,
      doctorIcon,
      doctorName,
      patientIDFromIM,
      patientName
    }
  } = data
  let title = `${fromName || ''}受者邀请您视频通话`
  let content = ''
  if (isMe) {
    title = `和${fromName}视频通话`
    content = '系统将通过电话提醒受者进入视频，请耐心等待片刻'
  } else {
    // initBackgroundAudio()
  }

  Dialog({
    title,
    message: content,
    showCancelButton: true,
    confirmButtonText: '进入视频',
    success({ confirm }) {}
  })
    .then(res => {
      console.log(res)
      if (backgroundAudio) {
        backgroundAudio.src = ''
        backgroundAudio = null
      }
      isOpenVideoModel = false
      setMessageRead(`GROUP${visitID}`) // 设置消息已读，避免重复弹框
      if (isMe && typeof cb === 'function') {
        cb()
      }
      // roomID 房间id fromName邀请方姓名 invited当前用户是被邀请
      // invited 穿true false会变成字符串
      const userData = {
        ...data
      }
      delete userData.isMe
      // 通知app拨打视频
      nativeBridge.sendMessage(
        new NativeMessageNotice({
          type: 'yltxSendTencentCall',
          params: {
            id,
            imSign: store.state.IM.imSign,
            userID: store.state.userId,
            roomID,
            id,
            title,
            userIDList: (userIDList || []).filter(item => {
              return item && item != 'null' && item != 'undefined'
            }),
            userData: JSON.stringify(userData)
          }
        })
      )
    })
    .catch(() => {
      if (backgroundAudio) {
        backgroundAudio.src = ''
        backgroundAudio = null
      }
      isOpenVideoModel = false
      setMessageRead(`GROUP${visitID}`) // 设置消息已读，避免重复弹框
    })
}

const setNavigationBarTitle = ({ content }) => {
  // const url = 'subpackage/pages/chat/chat'
  // const pages = getCurrentPages()
  // if (pages[pages.length - 1] && pages[pages.length - 1].route === url) {
  //   let title = content.status ? '正在输入中...' : `${content.title}`
  //   uni.setNavigationBarTitle({
  //     title
  //   })
  // }
}

export const hasLiveGroupId = async id => {
  // 获取视频通话群组id
  if (!imInstance) {
    // im只能初始一次
    return
  }
  try {
    const {
      data: { groupList }
    } = await imInstance.getGroupList()
    if (groupList && groupList.length) {
      const target = groupList.find(item => String(item.groupID) === id)
      return !!target
    }
  } catch (e) {
    console.log(e)
  }
  return false
}

export const initVideoLiveGroupID = async (id = '', memberList = []) => {
  // 获取视频通话群组id
  if (!imInstance) {
    // im只能初始一次
    return
  }
  const {
    data: { groupList }
  } = await imInstance.getGroupList()
  console.log('groupList----@:', groupList)
  if (groupList && groupList.length) {
    const target = groupList.find(item => String(item.groupID) === id)
    if (target) {
      return
    }
  }
  try {
    const {
      data: {
        group: { groupID }
      }
    } = await imInstance.createGroup({
      type: TIM.TYPES.GRP_PUBLIC,
      name: '多人通话public',
      groupID: id,
      memberList
    })
  } catch (e) {
    console.log(e)
  }
}

const updateLastMessageTime = (message = []) => {
  // 发送消息、接收消息、删除、撤销修改展示时间
  const nItem = message[0]
  if (nItem.time - lastMessageTime > 60 * 5) {
    // 时间间隔5分钟
    nItem.showTime = true
    lastMessageTime = nItem.time
  }
}

const bindImEvent = _tim => {
  const MESSAGE_RECEIVED = event => {
    console.log(event, '接收消息')
    const messageData = Array.isArray(event.data) ? event.data : [event.data]
    const curConversationID = store.state.IM.message.conversationId
    if (!curConversationID) {
      // 没有会话id,可能是受者发起的视频通话
      // 没有会话id,直接获取收到最新一条消息的 conversationID
      const { conversationID } = messageData[0]
      store.commit('IM/message/setConversationId', conversationID)
    }

    let content = {}
    try {
      const {
        flow,
        payload: { data }
      } = event.data[0]
      if (data) {
        content = JSON.parse(data)
      }
      if (String(content.type) === '50' && flow === 'in') {
        // 是视频消息弹出视频弹框
        store.commit('IM/SET_INVITATION', content.content || {})
        canEnterRoom() && toVideoCall(content, undefined, true)
      }
    } catch (e) {
      console.log(e)
    }
    // 过滤掉不是当前会话的消息
    event.data = messageData.filter(item => {
      item.flow === 'in' && updateConversationListUnreadMessage(item) // 更新会话列表未读消息数
      return item.conversationID === curConversationID
    })
    if (event.data.length === 0) {
      return
    }
    const {
      payload: { data, description }
    } = event.data[0]
    content = {}
    try {
      if (data) {
        content = JSON.parse(data)
      }
    } catch (e) {
      console.log(e)
    }
    if (description !== 'setStatus') {
      // 接受到设置用户标题状态消息不加入消息列表
      updateLastMessageTime(event.data)
      store.commit('IM/message/pushList', event.data)
      store.commit('IM/SET_IM_MESSAGE', event)
      store.commit('IM/message/setLastMessage', true)
    } else {
      // 时设置用户输入中...
      setNavigationBarTitle(content)
    }
  }
  const MESSAGE_REVOKED = event => {
    console.log(event, 'message_revoked')
    store.commit('IM/message/removeMessage', event.data[0])
    store.commit('IM/SET_IM_REVOKED', event)
    if (event && event.data && event.data.length) {
      event.data.forEach(item => {
        item.flow === 'in' && updateConversationListUnreadMessage(item, -1) // 更新会话列表未读消息数
      })
    }
  }
  const SDK_READY = event => {
    console.log(event, 'isReady')
    store.commit('IM/SET_IM_READY', true)
    store.commit('IM/message/resetList') // 清楚聊天列表，更新消息
    const conversationId = store.state.IM.message.conversationId

    // 当前有会话id更新会话列表，然后发送异步任务,没有会话id不执行
    const queue = taskQueue
    taskQueue = new Set()
    if (conversationId) {
      getMessageList(() => {
        if (queue.size) {
          for (const task of queue) {
            task()
          }
        }
      })
    }
    getConversationListUnreadNum() // 初始会话列表，设置会话列表未读消息使用
    isRelogin = false
  }
  const KICKED_OUT = event => {
    console.log('IM账号被踢下线', event, TIM.TYPES.KICKED_OUT_MULT_ACCOUNT)
    if (event.data.type === TIM.TYPES.KICKED_OUT_MULT_ACCOUNT) {
      // 同一账号，多页面登录被踢
      store.commit('IM/SET_IM_READY', false)
    }
  }
  const SDK_NOT_READY = event => {
    store.commit('IM/SET_IM_READY', false)
    console.log(event, 'no_ready')
  }
  const IM_ERROR = event => {
    store.commit('IM/SET_IM_READY', false)
    console.log(event, 'error')
  }
  const onConversationListUpdated = async ({ data: conversationList = [] }) => {
    // console.log(conversationList, '会话列表更新') // 包含 Conversation 实例的数组
  }
  _tim.on(TIM.EVENT.SDK_READY, SDK_READY)
  _tim.on(TIM.EVENT.SDK_NOT_READY, SDK_NOT_READY)
  _tim.on(TIM.EVENT.KICKED_OUT, KICKED_OUT)
  _tim.on(TIM.EVENT.MESSAGE_RECEIVED, MESSAGE_RECEIVED)
  _tim.on(TIM.EVENT.MESSAGE_REVOKED, MESSAGE_REVOKED)
  _tim.on(TIM.EVENT.ERROR, IM_ERROR)
  _tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, onConversationListUpdated)
}

// 跳转转诊详情
export const toInviteReferralDetail = id => {
  console.log(id)
  uni.navigateTo({
    url: `/mine/referral/detail?id=${id}`,
    fail: err => {
      console.log(err)
    }
  })
}

export const TIM_TYPE = TIM.TYPES

export const callbackStack = [] // 保存: 处方 诊疗（治疗） 病例
callbackStack.length = 3

export const cardCb = () => {
  // 病例回调
  console.log('打开病例')
  typeof callbackStack[2] === 'function' && callbackStack[2]()
}

export const surgeryCb = item => {
  // 手术回调
  console.log('打开手术回调')
  typeof callbackStack[3] === 'function' && callbackStack[3](item)
}

export const diagnosisCb = () => {
  // 诊疗回调
  console.log('打开诊疗')
  typeof callbackStack[1] === 'function' && callbackStack[1]()
}

export const prescriptionCb = () => {
  // 处方回调
  console.log('打开处方')
  typeof callbackStack[0] === 'function' && callbackStack[0]()
}

export const receiveInviteVideo = async data => {
  const nativeBridge = Vue.prototype.$nativeBridge
  console.log(data, '接受视频邀请')
  const {
    id,
    visitType,
    roomID,
    fromName,
    visitID,
    lowerDoctorIDFromIM,
    lowerDoctorName,
    doctorIDFromIM,
    doctorIcon,
    doctorName,
    patientIDFromIM,
    patientName
  } = data
  store.commit('IM/SET_INVITATION', data)
  const title = [patientName, lowerDoctorName, doctorName].join('、')
  // 这里是先写死了受者、下级医生、上级医生,最好是获取群组内所有人，后期优化赶工中
  const userIDList = JSON.stringify(
    [
      {
        userID: patientIDFromIM
      },
      {
        userID: lowerDoctorIDFromIM
      },
      {
        userID: doctorIDFromIM
      }
    ].filter(item => item.userID)
  )
  if (canEnterRoom()) {
    // 通知app拨打视频
    nativeBridge.sendMessage(
      new NativeMessageNotice({
        type: 'yltxSendTencentCall',
        params: {
          id,
          imSign: store.state.IM.imSign,
          userID: store.state.userId,
          roomID,
          title,
          userIDList
        }
      })
    )
  }
}

export const setInputStatus = async data => {
  // 设置用户输入状态
  // const isReady = store.state.IM.imReady
  // if (!isReady) {
  //   return
  // }
  // try {
  //   let message = imInstance.createCustomMessage(data)
  //   await imInstance.sendMessage(message)
  // } catch (e) {}
}

export const getMessageRecord = async () => {
  // 查询过后台消息后不再进行查询
  if (store.state.IM.isCompleted) {
    return
  }
  store.commit('IM/SET_IM_ISCOMPLETE', true)
  // 在腾讯查询不到消息后获取后台消息列表
  let messageList = await getMessageListRecord({
    hospitalID: store.state.hospitalId,
    visitID: store.state.IM.to
  })
  // 当前消息数量
  const sequence =
    (store.state.IM.message &&
      store.state.IM.message.currentMessageList &&
      store.state.IM.message.currentMessageList.length &&
      store.state.IM.message.currentMessageList[
        store.state.IM.message.currentMessageList.length - 1
      ] &&
      store.state.IM.message.currentMessageList[
        store.state.IM.message.currentMessageList.length - 1
      ].sequence) ||
    Infinity
  // 有可能出现我要查询前8天的消息记录，但是腾讯只保留了7天的消息，第8天的消息需要在后台查询
  // sequence(MsgSeq) 越小消息时间越久
  messageList = messageList.reduce((res, item) => {
    item.MsgSeq < sequence && res.push(item)
    return res
  }, [])
  messageList = formatImMessage(
    messageList,
    store.state.IM.to,
    store.state.imId || localStorage.getItem('IMID')
  )
  // console.log(messageList, store.state.IM.to, store.state.imId, 'ddhhhdhddhdhddd')
  let pre = 0
  // 1 系统消息只展示时间，不显示内容
  // 2 撤回消息 展示xxx撤回了一条消息
  // 3 其它消息正常展示
  // 4 自定义消息type=== 1000 ,设置用户输入状态不展示
  messageList = messageList.filter(item => {
    // const showTime = caculateTimeago(item.time * 1000)
    if (item.payload && item.payload.description === 'setStatus') {
      // 过滤掉设置用户状态的消息
      return false
    }
    if (item.time - pre > 60 * 5) {
      // 时间间隔5分钟
      item.showTime = true
      pre = item.time
    }
    return true
  })
  store.commit('IM/message/unshiftList', messageList)
}

/**
 * 获取消息列表,im获取当前时间~7天之前的消息列表, 7天之前的聊天列表从后台获取
 * 1、群组未解散，聊天消息只有7天内的;
 * 2、群组未解散，聊天消息有7天之前的和7天内的;
 * 3、群组未解散、聊天消息只有7天之前的
 * 4、群组已经解散
 *
 * 场景：1、2、3 在查询到腾讯消息列表后会查询后台聊天列表，
 * 根据消息记录中的MsgSeq 和sequence 字段从后台返回的聊天消息筛选出7天之前的聊天列表
 * 场景：4
 * **/

export const getMessageList = async cb => {
  const isReady = store.state.IM.imReady
  if (!isReady) {
    // taskQueue.add(() => {
    //   store.commit('IM/message/resetList') // 修复自动登录后获取消息列表报错
    //   getMessageList()
    // })
    reLogin()
    return
  }
  if (store.state.IM.message.isCompleted) {
    return
  }
  const { nextReqMessageID, conversationId } = store.state.IM.message
  try {
    let {
      // eslint-disable-next-line
      data: { nextReqMessageID: nextId, isCompleted, messageList }
    } = await imInstance.getMessageList({
      conversationID: conversationId,
      nextReqMessageID,
      count: 15
    })
    // 更新messageID，续拉时要用到
    store.commit('IM/message/setNextReqMessageID', nextId)
    store.commit('IM/message/setIsCompleted', isCompleted)
    let pre = 0
    // 1 系统消息只展示时间，不显示内容
    // 2 撤回消息 展示xxx撤回了一条消息
    // 3 其它消息正常展示
    messageList = messageList.filter(item => {
      // const showTime = caculateTimeago(item.time * 1000)
      if (item.payload && item.payload.description === 'setStatus') {
        // 过滤掉设置用户状态的消息
        return false
      }
      if (item.time - pre > 60 * 5) {
        // 时间间隔5分钟
        item.showTime = true
        pre = item.time
      }
      return true
    })
    if (!nextReqMessageID) {
      // 第一页, 重置最新消息
      console.log(pre, 'lastMessageTime')
      lastMessageTime = pre
    }
    store.commit('IM/message/unshiftList', messageList)
    typeof cb === 'function' && cb() // 执行taskQueue 中异步任务
    if (isCompleted) {
      // 场景 1、2、3 查询消息列表
      await getMessageRecord()
    }
  } catch (e) {
    // 无效的群组 ID，表示群组不存在或已经被解散。code: 10015
    // 群组不存在，或者曾经存在过，但是目前已经被解散。code: 10010
    const errorCode = ['10015', '10010']
    if (errorCode.includes(String(e.code))) {
      // 场景4 查询消息列表
      await getMessageRecord()
    }
  }
}

const conversationUnreadVideoMessage = async (list = []) => {
  const oldTime = new Date().getTime() - 5 * 60 * 1000 // 5分钟之前
  const oldTimeSec = parseInt(oldTime / 1000, 10)
  const videoMessage = list.reduce(
    (res, { flow, type, time, payload }) => {
      if (flow === 'in' && type === TIM.TYPES.MSG_CUSTOM && time > oldTimeSec) {
        // 筛选自定义消息
        try {
          let payloadObj = {}
          if (payload && payload.data) {
            payloadObj = JSON.parse(payload.data)
            if (String(payloadObj.type) === '50' && time > res.time) {
              res.time = time
              res.data = payloadObj
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
      return res
    },
    {
      time: 0,
      data: null
    }
  )
  if (videoMessage.data) {
    store.commit('IM/SET_INVITATION', videoMessage.data.content || {})
    canEnterRoom() && toVideoCall(videoMessage.data, undefined, true)
  }
}

// 循环调用会话，获取到所有未读消息
const getConversationProfileList = async conversationList => {
  // const stack = []
  const result = []
  let curNextReqMessageID
  const len = conversationList.length
  const getConversationMessage = async ({
    unreadCount,
    conversationID,
    nextReqMessageID = '',
    isCompleted
  }) => {
    let list = []
    if (!unreadCount || isCompleted) {
      return list
    }
    try {
      const {
        // eslint-disable-next-line
        data: { messageList, nextReqMessageID: nextId, isCompleted: isAll }
      } = await imInstance.getMessageList({
        nextReqMessageID,
        conversationID,
        count: unreadCount
      })
      list = messageList
      if (unreadCount < 15) {
        // 小于15说明是最后一页
        curNextReqMessageID = ''
        // curIsCompleted = false
      } else {
        curNextReqMessageID = nextId
        // curIsCompleted = isAll
      }
    } catch (e) {
      return list
    }
    return list
  }
  for (let i = 0; i < len; i++) {
    const item = conversationList[i]
    // eslint-disable-next-line
    let { unreadCount, conversationID, unreadNum } = item
    if (unreadNum === undefined) {
      item.unreadNum = unreadCount
      unreadNum = unreadCount
    }
    let pageSize = 15
    if (unreadNum >= 15) {
      // 多页需要循环查询多页
      i--
    }
    pageSize = Math.min(pageSize, unreadNum)
    const res = await getConversationMessage({
      unreadCount: pageSize,
      nextReqMessageID: curNextReqMessageID,
      conversationID
    })
    item.unreadNum -= pageSize
    res && res.length && result.push(...res)
  }
  return result
}

const clearConversationUnreadNum = conversationId => {
  // 清0会话列表未读数
  let list = store.state.IM.list.conversationList
  list = JSON.parse(JSON.stringify(list))
  if (!list || list.length === 0) {
    return
  }
  const item = list.find(item => item.conversationID === conversationId)
  if (!item) {
    return
  }
  item.unreadCount = 0
  store.commit('IM/list/SET_CONVERSTAION_LIST', list)
}

export const updateConversationListUnreadMessage = (message, increase = 1) => {
  // 更新会话列表里面某个会话未读消息
  let list = store.state.IM.list.conversationList || []
  list = JSON.parse(JSON.stringify(list))
  const item = list.find(item => item.conversationID === message.conversationID)
  if (!item) {
    // 总列表没有查询到更新会话列表
    getConversationListUnreadNum()
    return
  }
  if (!Number(item.unreadCount)) {
    item.unreadCount = 0
  }
  if (filterRevoredMessage(message)) {
    // 筛选掉不计数的消息
    item.unreadCount += increase
    item.unreadCount < 0 && (item.unreadCount = 0) // 避免可能出现的负值
  }
  store.commit('IM/list/SET_CONVERSTAION_LIST', list)
}

// 撤回
export const filterRevoredMessage = ({ isRead, isRevoked, type, isDeleted, payload, flow }) => {
  if (flow === 'out') {
    // 自己发的消息不计数，out是自己发送消息
    return
  }

  if ([TIM_TYPE.CONV_SYSTEM, TIM_TYPE.MSG_GRP_TIP, TIM_TYPE.MSG_GRP_SYS_NOTICE].includes(type)) {
    // 系统消息不计数, 群组消息不计数,群系统通知消息
    return
  }

  if (type !== TIM_TYPE.MSG_CUSTOM) {
    // 非自定义消息计数
    return true
  }

  if (type === TIM_TYPE.MSG_CUSTOM) {
    // 自定义消息，type=99不计数
    let customData = {}
    try {
      const { data } = payload
      customData = JSON.parse(data)
    } catch (e) {
      console.log(e)
    }
    if (['99', '20', '10'].includes(String(customData.type))) {
      return false
    }
    return true
  }

  // 其它全计数
  return true
}

// 过滤未读消息
export const filterUnreadMessage = ({ isRead, isRevoked, type, isDeleted, payload, flow }) => {
  // 过滤消息的规则
  if (isRead) {
    // 已读不计数
    return
  }

  if (flow === 'out') {
    // 自己发的消息不计数，out是自己发送消息
    return
  }

  if (isRevoked || isDeleted) {
    // 撤销或者是删除
    return
  }

  if ([TIM_TYPE.CONV_SYSTEM, TIM_TYPE.MSG_GRP_TIP, TIM_TYPE.MSG_GRP_SYS_NOTICE].includes(type)) {
    // 系统消息不计数, 群组消息不计数,群系统通知消息
    return
  }

  if (type !== TIM_TYPE.MSG_CUSTOM) {
    // 非自定义消息计数
    return true
  }

  if (type === TIM_TYPE.MSG_CUSTOM) {
    // 自定义消息，type=99不计数
    let customData = {}
    try {
      const { data } = payload
      customData = JSON.parse(data)
    } catch (e) {
      console.log(e)
    }
    if (['99', '20', '10'].includes(String(customData.type))) {
      return false
    }
    return true
  }

  // 其它全计数
  return true
}

export const getConversationListUnreadNum = async () => {
  // 获取所有会话列表
  const isReady = store.state.IM.imReady
  const list = []
  if (!isReady) {
    return
  }
  try {
    const {
      data: { conversationList = [] }
    } = await imInstance.getConversationList()
    if (conversationList.length) {
      // 用户登录后获取所有会话未读消息
      const messageList = await getConversationProfileList(conversationList)
      // 用户登录后获取是否有离线视频消息
      conversationUnreadVideoMessage(messageList)
      const hash = conversationList.reduce((res, conversation) => {
        const { conversationID } = conversation
        const temp = {
          unreadCount: 0,
          conversationID
        }
        res[conversationID] = temp
        list.push(temp)
        return res
      }, {})
      messageList.forEach(message => {
        if (filterUnreadMessage(message)) {
          hash[message.conversationID].unreadCount++
        }
      })
    }
    store.commit('IM/list/SET_CONVERSTAION_LIST', list) // 更新vuex 会话列表
  } catch (e) {
    console.log(e)
  }
}

export const getConversationProfile = async conversationId => {
  const isReady = store.state.IM.imReady
  if (!isReady) {
    taskQueue.add(() => {
      getConversationProfile(conversationId)
    })
    reLogin()
    return
  }
  const {
    data: { conversation }
  } = await imInstance.getConversationProfile(conversationId)
  store.commit('IM/message/setConversationProfile', conversation || {})
  // console.log(conversation, '会话资料')
}

export const setMessageRead = async conversationId => {
  const isReady = store.state.IM.imReady
  if (!isReady || !imInstance) {
    taskQueue.add(() => {
      setMessageRead(conversationId)
    })
    reLogin()
    return
  }
  clearConversationUnreadNum(conversationId) // 重置未读消息
  await imInstance.setMessageRead({
    conversationID: conversationId
  })
}

export const sendTextMessage = async (data, messageCb, sendMsgCb) => {
  const isReady = store.state.IM.imReady
  console.log(isReady, 'isReady---')
  if (!isReady) {
    taskQueue.add(() => {
      sendTextMessage(data, messageCb, sendMsgCb)
    })
    reLogin()
    return
  }
  const message = imInstance.createTextMessage(data)
  typeof messageCb === 'function' && messageCb(message)
  try {
    Object.assign(message, {
      showTime: false, // 是否展示时间
      fail: false, // 发送失败图标
      loading: true, // 加载图标
      progress: 0 // 进度条
    })
    updateLastMessageTime([message])
    store.commit('IM/message/setLastMessage', true)
    store.commit('IM/message/pushList', message)
    typeof sendMsgCb === 'function' && sendMsgCb(message)
    await imInstance.sendMessage(message)
    message.loading = false
    // typeof sendMsgCb === 'function' && sendMsgCb(message)
  } catch (e) {
    message.fail = true
  }
}

export const sendImageMessage = async (data, messageCb, sendMsgCb) => {
  const isReady = store.state.IM.imReady
  if (!isReady) {
    taskQueue.add(() => {
      sendImageMessage(data, messageCb, sendMsgCb)
    })
    reLogin()
    return
  }
  let percentEvent = null
  if (data.onProgress) {
    percentEvent = data.onProgress
  }
  data.onProgress = e => {
    percentEvent && percentEvent()
    message.progress = e
  }
  const message = imInstance.createImageMessage(data)
  typeof messageCb === 'function' && messageCb(message)
  try {
    Object.assign(message, {
      showTime: false, // 是否展示时间
      fail: false, // 发送失败图标
      loading: true, // 加载图标
      showProgress: true, // 是否显示进度条
      progress: 0 // 进度条
    })
    updateLastMessageTime([message])
    store.commit('IM/message/pushList', message)
    store.commit('IM/message/setLastMessage', true)
    typeof sendMsgCb === 'function' && sendMsgCb(message)
    await imInstance.sendMessage(message)
    message.loading = false
    message.showProgress = false
    // typeof sendMsgCb === 'function' && sendMsgCb(message)
  } catch (e) {
    message.fail = true
  }
}

export const sendAudioMessage = async (data, messageCb, sendMsgCb) => {
  const isReady = store.state.IM.imReady
  if (!isReady) {
    taskQueue.add(() => {
      sendAudioMessage(data, messageCb, sendMsgCb)
    })
    reLogin()
    return
  }
  const message = imInstance.createAudioMessage(data)
  typeof messageCb === 'function' && messageCb(message)
  try {
    Object.assign(message, {
      showTime: false, // 是否展示时间
      fail: false, // 发送失败图标
      loading: true, // 加载图标
      progress: 0 // 进度条
    })
    updateLastMessageTime([message])
    store.commit('IM/message/pushList', message)
    store.commit('IM/message/setLastMessage', true)
    typeof sendMsgCb === 'function' && sendMsgCb(message)
    await imInstance.sendMessage(message)
    message.loading = false
    // typeof sendMsgCb === 'function' && sendMsgCb(message)
  } catch (e) {
    message.fail = true
  }
}

export const sendVideoMessage = async (data, messageCb, sendMsgCb) => {
  const isReady = store.state.IM.imReady
  if (!isReady) {
    taskQueue.add(() => {
      sendVideoMessage(data, messageCb, sendMsgCb)
    })
    reLogin()
    return
  }
  let percentEvent = null
  if (data.onProgress) {
    percentEvent = data.onProgress
  }
  data.onProgress = e => {
    percentEvent && percentEvent()
    message.progress = e
  }
  const message = imInstance.createVideoMessage(data)
  typeof messageCb === 'function' && messageCb(message)
  try {
    Object.assign(message, {
      showTime: false, // 是否展示时间
      fail: false, // 发送失败图标
      loading: true, // 加载图标
      progress: 0 // 进度条
    })
    updateLastMessageTime([message])
    store.commit('IM/message/pushList', message)
    store.commit('IM/message/setLastMessage', true)
    typeof sendMsgCb === 'function' && sendMsgCb(message)
    await imInstance.sendMessage(message)
    message.loading = false
    // typeof sendMsgCb === 'function' && sendMsgCb(message)
  } catch (e) {
    message.fail = true
  }
}

export const sendFaceMessage = async (data, messageCb, sendMsgCb) => {
  const isReady = store.state.IM.imReady
  if (!isReady) {
    taskQueue.add(() => {
      sendFaceMessage(data, messageCb, sendMsgCb)
    })
    reLogin()
    return
  }
  const message = imInstance.createFaceMessage(data)
  typeof messageCb === 'function' && messageCb(message)
  try {
    Object.assign(message, {
      showTime: false, // 是否展示时间
      fail: false,
      loading: true,
      progress: 0
    })
    updateLastMessageTime([message])
    store.commit('IM/message/pushList', message)
    store.commit('IM/message/setLastMessage', true)
    typeof sendMsgCb === 'function' && sendMsgCb(message)
    await imInstance.sendMessage(message)
    message.loading = false
    // typeof sendMsgCb === 'function' && sendMsgCb(message)
  } catch (e) {
    message.fail = true
  }
}

export const sendCustomMessage = async (data, messageCb, sendMsgCb) => {
  const isReady = store.state.IM.imReady
  if (!isReady) {
    taskQueue.add(() => {
      sendCustomMessage(data, messageCb, sendMsgCb)
    })
    reLogin()
    return
  }
  const message = imInstance.createCustomMessage(data)
  typeof messageCb === 'function' && messageCb(message)
  try {
    Object.assign(message, {
      showTime: false, // 是否展示时间
      fail: false,
      loading: true,
      progress: 0
    })
    updateLastMessageTime([message])
    store.commit('IM/message/pushList', message)
    store.commit('IM/message/setLastMessage', true)
    typeof sendMsgCb === 'function' && sendMsgCb(message)
    await imInstance.sendMessage(message)
    message.loading = false
    // typeof sendMsgCb === 'function' && sendMsgCb(message)
  } catch (e) {
    message.fail = true
  }
}

export const revokeMessage = async (message, sendMsgCb) => {
  const isReady = store.state.IM.imReady

  if (!isReady) {
    taskQueue.add(() => {
      revokeMessage(message, sendMsgCb)
    })
    reLogin()
    return
  }
  try {
    const imResponse = await imInstance.revokeMessage(message)
    typeof sendMsgCb === 'function' && sendMsgCb(imResponse)
    const {
      data: { message: revokeMsg }
    } = imResponse
    store.commit('IM/message/removeMessage', revokeMsg)
    store.commit('IM/message/setLastMessage', true)
  } catch (e) {
    console.log(e)
  }
}

export const getSign = async imId => {
  if (store.state.IM && store.state.IM.imSign) {
    return
  }
  try {
    // 获取签名
    const imSign = await getImUserSig(imId)
    store.commit('IM/SET_SIGN', imSign)
    // const videoSign = await getVideoUserSig(imId)
    // store.commit('IM/SET_TRTC_CONFIG', videoSign)
    return {
      imSign
      // videoSign
    }
  } catch (e) {
    console.log(e)
  }
}

export const timInit = async imSign => {
  if (imInstance) {
    // im只能初始一次
    return
  }
  let _tim
  try {
    // im初始失败可以重新实例
    _tim = TIM.create({
      SDKAppID: Number(imSign.sdkAppID)
    })
  } catch (e) {
    uni.showModal({
      title: '提示',
      content: 'IM初始失败，请在网络状态良好时重新进入小程序'
    })
    return
  }
  imInstance = _tim
  _tim.setLogLevel(1)
  _tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })
  bindImEvent(_tim)
}

export const imLogin = async imSign => {
  if (!imInstance) {
    return
  }
  try {
    await imInstance.login({ userID: imSign.userID, userSig: imSign.userSig })
  } catch (e) {
    // 6250 请求时没有网络，请等网络恢复后重试
    // 6251 响应时没有网络，请等网络恢复后重试
    // 9501~9525 网络问题
    const { code } = e || {}
    if (
      (Number(code) >= 9501 && Number(code) <= 9525) ||
      Number(code) === 6250 ||
      Number(code) === 6251
    ) {
      uni.showModal({
        title: '提示',
        content: 'IM登录失败，请在网络状态良好时新进入小程序'
      })
    }
  }
}

export const imLogout = async _tim => {
  if (!imInstance) {
    return
  }
  await imInstance.logout()
}

export const initIm = async imId => {
  if (isRelogin || !imId) {
    // 修复im重复登录
    return
  }
  isRelogin = true
  await getSign(imId)
  const imSign = store.state.IM.imSign
  await timInit(imSign)
  await imLogin(imSign)
}
